import {
	map,
	when,
	propEq,
	find, pluck, reduce, concat, findIndex, path,
} from 'ramda';
import Vue from 'vue';
import bus from '@/bus/app-bus';
import { parseHierarchyAssignation, parseAssignationRequest, commandMap, parseOrganizationChart } from '../../utils/guideline-model/helpers';

const LOADER_EVENT = 'app-event-loader-toggle-view';
const LOADER_MESSAGE = 'Praktiko esta asignando las jerarquias.';
const LOADER_MESSAGE_ORGANIZATIONAL_CHART = 'Praktiko esta generando el organizagrama.';

export default {
	async getJobValuationStatus({ commit }) {
		try {
			const { status } = await Vue.prototype.$http.get('/polls/JEV');
			commit('UPDATE_HAS_INFORMATION', status === 200);
			return true;
		} catch (e) {
			throw e;
		}
	},
	updateJobList({ commit }, jobList) {
		commit('UPDATE_LIST', jobList);
	},
	updateJobItem({ commit, state }, job) {
		const jobList = map(
			when(
				propEq('name', job.name),
				() => ({ ...job }),
			),
			state.supplies.guidelineModel.userForm.jobList,
		);
		commit('UPDATE_LIST', jobList);
	},
	async loadJobEvaluationConfig({ commit }) {
		const JOB_EVALUATION_TOOL_CODE = 'JEV';
		const { data } = await Vue.prototype.$http.get(`/tools/${JOB_EVALUATION_TOOL_CODE}`);
		commit('UPDATE_MAIN_DATA', data);
	},
	async loadRoles({ commit }) {
		const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/ROL');
		commit('UPDATE_LEVEL_SELECTION_ROLE', {
			name: 'Rol',
			data,
		});
	},
	async loadTitles({ commit }) {
		const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/TIT');
		commit('UPDATE_LEVEL_SELECTION_TITLE', {
			name: 'Título',
			data,
		});
	},
	async loadExperiences({ commit }) {
		const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/EXP');
		commit('UPDATE_LEVEL_SELECTION_EXPERIENCE', {
			name: 'Experiencia',
			data,
		});
	},
	async loadVerbs({ commit }) {
		try {
			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/VER');
			commit('UPDATE_COMMAND_DATA', {
				command: 'highCommand',
				data: find(propEq('code', commandMap.highCommand), data),
			});
			commit('UPDATE_COMMAND_DATA', {
				command: 'mediumCommand',
				data: find(propEq('code', commandMap.mediumCommand), data),
			});
			commit('UPDATE_COMMAND_DATA', {
				command: 'lowCommand',
				data: find(propEq('code', commandMap.lowCommand), data),
			});
			return true;
		} catch (e) {
			throw new Error(e);
		}
	},
	async getGuidelineModelStatus({ commit }) {
		const { data: { details, jobs } } = await Vue.prototype.$http.get('/polls/JEV?organizationChart=true');
		if (details) {
			const parsedAssignations = parseHierarchyAssignation(details);
			const concatAll = reduce(concat, []);
			commit('UPDATE_LIST', concatAll(pluck('jobPositions', parsedAssignations)));
			commit('UPDATE_HIERARCHY_ASSIGNATION', parsedAssignations);
		}
		commit('UPDATE_ORGANIZATION_CHART', jobs || []);
	},
	async assignHierarchy({ state }) {
		bus.$emit(LOADER_EVENT, { show: true, message: LOADER_MESSAGE });
		try {
			const payloadRequest = parseAssignationRequest(state);
			await Vue.prototype.$httpPraktiko.post('/polles/unique', payloadRequest);
			bus.$emit(LOADER_EVENT, { show: false });
			return true;
		} catch (e) {
			bus.$emit(LOADER_EVENT, { show: false });
			throw e;
		}
	},
	async generateOrganizationChart({ state }) {
		bus.$emit(LOADER_EVENT, { show: true, message: LOADER_MESSAGE_ORGANIZATIONAL_CHART });
		try {
			await Vue.prototype.$httpPraktiko.post('/polles/unique', parseOrganizationChart(state));
			bus.$emit(LOADER_EVENT, { show: false });
			return true;
		} catch (e) {
			bus.$emit(LOADER_EVENT, { show: false });
			throw e;
		}
	},
	updateAssignation({ state, commit }, { jobPosition, assignationId }) {
		const hierarchyAssignation = path(['supplies', 'guidelineModel', 'hierarchyAssignation'], state);
		const assignationIndex = findIndex(propEq('id', assignationId), hierarchyAssignation);
		const jobPositionIndex = findIndex(propEq('id', jobPosition.id), path([assignationIndex, 'jobPositions'], hierarchyAssignation));
		commit('UPDATE_JOB_POSITION_ASSIGNATION', { assignationIndex, jobPositionIndex, jobPosition });
	},
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/guideline-model/actions.js